export const PATIENT_ID_REGEXP = /^[0-9]+$/;
export const ONLY_NUMBERS_REGEXP = /^[0-9]+$/;
export const AGE_REGEXP = /^[1-9][0-9]*$/;
export const MINIMAL_COUNT_REGEXP = /^\d{1,30}$/;
export const PHONE_NUMBER_REGEXP = /^(\+){0,1}[\d\s]{9,16}$/;
export const USER_PASSWORD_REGEXP =
  /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[#?!@$%^&*+\-=/])[A-Za-z\d#?!@$%^&*+\-=/]{8,15}$/;
export const FEV1_REGEXP = /^(100|[1-9]?\d)$/;
export const GET_SDH_ID_FROM_QR_CODE_REGEXP = /\$+\+([^/]+)/;
export const SPLIT_COPY = /\D/g;
